import {ClassComponent, Vnode} from 'mithril';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Select from 'flarum/common/components/Select';
import Tooltip from 'flarum/common/components/Tooltip';
import icon from 'flarum/common/helpers/icon';
import extractText from 'flarum/common/utils/extractText';
import {License} from '../../common/json-settings';
import translate from '../../common/utils/translate';

interface LicenseLabelAttrs {
    value: string | null
    onchange: (value: string | null) => void
    disabled?: boolean
    editable: boolean
}

export default class LicenseLabel implements ClassComponent<LicenseLabelAttrs> {
    view(vnode: Vnode<LicenseLabelAttrs, this>) {
        const {value, onchange, disabled} = vnode.attrs;

        const licenses: License[] = app.forum.attribute('cimaiseLicenses') || [];
        const selected = licenses.find(license => license.key === value);

        let options: { [key: string]: string } = {};

        const notSpecifiedText = extractText(app.translator.trans('kilowhat-cimaise.forum.license-label.not-specified'));

        if (!app.forum.attribute('cimaiseLicenseRequired')) {
            options['_none'] = notSpecifiedText;
        }

        licenses.forEach(license => {
            options[license.key] = translate(license.label);
        });

        return m('.LicenseLabel', [
            icon('far fa-copyright', {
                className: 'LicenseLabel-icon',
            }),
            vnode.attrs.editable ? Select.component({
                value: value === null ? '_none' : value,
                options,
                onchange(value: string) {
                    onchange(value === '_none' ? null : value);
                },
                disabled,
            }) : (selected ? translate(selected.label) : notSpecifiedText),
            m('span', Tooltip.component({
                key: value, // Force a re-creation of the tooltip when the value changes
                text: selected ? (translate(selected.label) + ':\n\n' + translate(selected.description)) : extractText(app.translator.trans('kilowhat-cimaise.forum.license-label.not-specified-help')),
            }, Button.component({
                className: 'Button Button--icon Button--flat LicenseLabel-help',
                icon: 'far fa-question-circle',
            }))),
        ]);
    }
}
